const updateStatusVerificationItems = {
  toastr: 'Tipo de Servicio actualizado',
  toastr1: ' fue actualizado con éxito',
  toastrError: 'Tipo de Servicio ya registrado',
  toastrError: 'Ingrese otro nombre'
};

export default updateStatusVerificationItems;
